import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            layerStyle: 'full-width',
            width: '100%',
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
            pt: remCalc(8),
            pb: remCalc(24),
        },
        outerContainerScroll: {
            width: '100%',
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
        },
        headerLabel: {
            py: {
                base: remCalc(16),
                md: remCalc(16),
                lg: remCalc(40),
            },
            px: {
                base: remCalc(16),
                md: remCalc(24),
            },
            position: 'sticky',
            textStyle: 'head-large',
            fontWeight: 'medium',
            noOfLines: 2,
        },
        imageStyle: {
            width: '100%',
            height: '100%',
        },
        recommendedProductCard: {
            flexDir: 'column',
            minW: {base: remCalc(300), lg: '33%', xl: remCalc(320)},
            flex: '0',
        },
        productsContainer: {
            overflowX: 'scroll',
            justifyContent: 'space-between',
            '::-webkit-scrollbar': {
                display: {base: 'none', xl: 'flex'},
            },
        },
        noSelect: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            img: {
                WebkitUserDrag: 'none',
                userDrag: 'none',
                pointerEvents: 'none',
            },
        },
        scrollableContainer: {
            overflowX: 'scroll',
            justifyContent: 'space-between',
            '::-webkit-scrollbar': {
                display: {base: 'none', xl: 'flex'},
            },
            gap: {base: remCalc(8), md: 'small.sm', lg: 'small.md', xl: 'small.md'},
            px: {base: remCalc(16), md: remCalc(24)},
        },
        productsWrapper: {
            overflow: 'auto',
        },
        productDetailsContainer: {
            flexDir: 'column',
            mx: 0,
            gap: remCalc(8),
            fontWeight: 'normal',
            marginBottom: {base: remCalc(16), lg: remCalc(24)},
        },
        productDetailId: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        productDetailName: {
            textStyle: 'body-medium',
            color: 'text.default',
            'text-wrap': 'auto',
            minHeight: remCalc(48),
            noOfLines: 2,
            pr: remCalc(10),
        },
        productDetailPrice: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'normal',
        },
        productListPrice: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        productOmnibusWrapper: {
            h: remCalc(20),
        },
        discoverMoreButton: {
            _hover: {
                textDecoration: 'none',
                bg: 'button.text.text-hover',
            },
        },
    },
    variants: {
        cartVariant: {
            outerContainer: {
                bg: 'none',
                w: 'auto',
                maxWidth: '100%',
                h: 'auto',
                alignSelf: 'flex-start',
                overflowX: {base: 'auto', md: 'auto', lg: 'hidden'},
            },
            outerContainerScroll: {
                position: 'relative',
                overflowX: 'hidden',
                // paddingTop: remCalc(24),
            },
            recommendedProductCard: {
                minW: {base: remCalc(226), lg: remCalc(213), xl: remCalc(213)},
                maxW: {base: remCalc(226), lg: remCalc(213), xl: remCalc(213)},
                flexShrink: '0',
            },
            productsContainer: {
                justifyContent: 'unset',
                gap: {base: remCalc(8), md: 'small.md'},
                overflowX: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '::-webkit-scrollbar': {display: 'none'},
                // flexWrap: {base: 'nowrap', lg: 'wrap'},
            },
            headerLabel: {
                marginLeft: 0,
                h: 'auto',
                marginBottom: 'unset',
            },
        },
        greyBackgroundVariant: {
            outerContainer: {
                layerStyle: 'full-width',
                width: '100%',
                overflowX: {base: 'auto', md: 'auto', lg: 'hidden'},
                flexShrink: 0,
                background: 'background.light',
                flexDir: 'column',
            },
        },
    },
}
